var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.img)?_c('div',{staticClass:"circular--portrait",style:(_vm.wrapperStyle)},[_c('img',{attrs:{"alt":"Referent","src":_vm.img}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }